<template>
    <div class="pt-10 memberProfile">
        <TwoColumnLayout>
            <template v-slot:banner>
                <Banner :data="getBrandBanner()" :single="true" />
            </template>
            <template v-slot:title>
            </template>
            <template v-slot:filters>
            </template>
            <template v-slot:form-content>
                <h1 class="pstitle mt-4 mt-sm-0 mb-4">{{this.Member?.Name}}</h1>
                <MemberProfile :Member="this.Member" />
            </template>
            <template v-slot:address>
                <contact-address />
            </template>
        </TwoColumnLayout>
    </div>
</template>
<script>
    import axios from 'axios'
    import getEndPoint, { teamMembersAPI } from '../../constants/api.config'
    import MemberProfile from '../../components/atoms/MemberProfile.vue'
    import TwoColumnLayout from "../../components/molecules/TwoColumnLayout.vue";
    import ContactAddress from "../../components/molecules/ContactAddress.vue";
    import Banner from '../../components/molecules/CarouselBanner.vue';
    import getBannerData from '../../constants/banner.config';
    export default {
        name: "ProfilePage",
        props:["dealerLocationId","id"],
        components: {
            MemberProfile,
            TwoColumnLayout,
            ContactAddress,
            Banner,
        },
        data() {
            return {
                Member: {}
            }
        },
        methods: {
            getMembers(data) {
                let b = [];
                data.forEach(element => {
                    b.push(
                        {
                            MemberID: element.id,
                            DealerLocationID: element.dealerLocationID,
                            Name: element.name,
                            Position: element.position,
                            PhotoURL: element.photoURL,
                            ProfileInfo: element.profileInfo
                        }
                    );
                });

                return b;
            },
            BindMembersData()
            {
                axios.get(getEndPoint(teamMembersAPI) + window.DEALER_LOCATION.dealerLocationID)
                    .then((response) => {
                        let members = this.getMembers(response.data);
                        this.Member = members.find(x => x.DealerLocationID == this.dealerLocationId && x.MemberID == this.id)
                    })
                    .catch((error) => console.log(error));
            },
            getBrandBanner(){
                return getBannerData(sessionStorage.getItem('brand'), 'profile');
            },
        },
        mounted() {
            this.BindMembersData();
        }
    };
</script>